var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAkamai = function SvgAkamai(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "1em",
    height: "1em"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "akamai_svg__a",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h612v792H0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#09c",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-6.127 1.862-10.58 7.517-10.58 14.209 0 6.763 4.548 12.465 10.768 14.279.637.189.472.59-.306.59-8.271 0-14.986-6.669-14.986-14.869S-8.389-.66-.118-.66C.66-.66.707-.212 0 0",
    style: {
      fill: "#09c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(5.60732 0 0 -5.60732 84.693 163.05)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0a10 10 0 0 0-.071 1.202 11.797 11.797 0 0 0 11.806 11.805c6.173 0 8.011-2.757 8.247-2.568.259.188-2.239 5.655-9.473 5.655A11.796 11.796 0 0 1-1.296 4.289c0-1.508.283-2.946.801-4.265C-.283-.542.047-.542 0 0",
    style: {
      fill: "#09c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(5.60732 0 0 -5.60732 41.355 102.799)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#09c",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0c3.063 1.343 6.928 1.39 10.721.047 2.545-.895 4.03-2.168 4.148-2.097.212.094-1.485 2.757-4.525 3.912A10.79 10.79 0 0 1-.165.259C-.495 0-.377-.165 0 0",
    style: {
      fill: "#09c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(5.60732 0 0 -5.60732 69.102 55.1)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#f93",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0-.848-.707-1.555-1.555-1.555-.849 0-1.555.683-1.555 1.555 0 .848.683 1.555 1.555 1.555S0 .872 0 0",
    style: {
      fill: "#f93",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(5.60732 0 0 -5.60732 409.333 86.283)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m525.457 729.914.188-2.074h3.276l-1.108 12.041h-4.877l-6.174-12.04h3.346l1.037 2.073zm-.165 2.333H522.3l2.57 5.207h.022zm8.177.849h.495l2.333 3.18h3.039l-3.228-4.052 1.98-4.383h-3.229l-1.296 3.417h-.471l-.73-3.417h-2.757l2.544 12.04h2.757z",
    style: {
      fill: "#f93",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(5.60732 0 0 -5.60732 -2820.89 4227.904)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#akamai_svg__a)",
    style: {
      fill: "#f93",
      fillOpacity: 1
    },
    transform: "matrix(5.60732 0 0 -5.60732 -2820.89 4227.904)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#f93",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h2.757l1.107 5.255C4.477 8.153 3.37 8.506.542 8.506c-1.979 0-3.888.024-4.43-2.591h2.757c.165.754.636.918 1.32.918 1.201 0 1.154-.494.989-1.272L.895 4.218H.778c-.095.966-1.32.942-2.098.942-2.002 0-3.181-.636-3.605-2.662-.447-2.144.566-2.616 2.498-2.616.966 0 2.262.189 2.71 1.343h.094Zm-.778 3.487c.896 0 1.485-.07 1.343-.777C.377 1.838 0 1.673-1.155 1.673c-.424 0-1.201 0-1.013.919.165.778.707.895 1.39.895",
    style: {
      fill: "#f93",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(543.649 727.84)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#f93",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-.259-1.178h.118C.401-.188 1.508.094 2.451.094c1.178 0 2.356-.212 2.191-1.649h.118C5.16-.353 6.386.094 7.446.094c1.956 0 2.781-.801 2.356-2.757L8.577-8.436H5.82l1.037 4.878c.141.872.283 1.532-.778 1.532-1.084 0-1.437-.707-1.626-1.626L3.44-8.436H.683l1.084 5.114c.142.777.189 1.296-.777 1.296-1.131 0-1.485-.613-1.697-1.626L-1.72-8.436h-2.757L-2.686 0Z",
    style: {
      fill: "#f93",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(551.99 736.277)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#f93",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h2.757l1.131 5.255c.613 2.898-.495 3.251-3.322 3.251-1.98 0-3.889.024-4.43-2.591h2.757c.164.754.636.918 1.319.918 1.202 0 1.155-.494.99-1.272L.919 4.218H.801c-.094.966-1.319.942-2.097.942-2.003 0-3.181-.636-3.605-2.662-.448-2.144.565-2.616 2.497-2.616.967 0 2.263.189 2.71 1.343h.095Zm-.754 3.487c.895 0 1.484-.07 1.343-.777-.188-.872-.565-1.037-1.72-1.037-.424 0-1.202 0-1.013.919.165.778.707.895 1.39.895",
    style: {
      fill: "#f93",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(566.906 727.84)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M573.669 727.84h-2.757l1.767 8.437h2.78z",
    style: {
      fill: "#f93",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(5.60732 0 0 -5.60732 -2820.89 4227.904)"
  }));
};
export default SvgAkamai;